import { ButtonProps } from '@sgme/ui';
import classNames from 'classnames';
import { HelpRequestButton } from 'components/help-request-button';
import { MouseEventHandler } from 'react';
import { FormattedMessage } from 'react-intl';
import { logAnalytics } from 'shared/middlewares/analytics/logger';
export function EssentialHelpCenterAction({
  iconOnly = false,
  className,
  isSmall = false,
  ...props
}: { iconOnly?: boolean; isSmall?: boolean } & ButtonProps) {
  const helperCenterHandler: MouseEventHandler<HTMLButtonElement> = () => {
    logAnalytics.trackEvent('Primary market essential', 'Contact help center');
  };

  return (
    <HelpRequestButton
      onClick={helperCenterHandler}
      className={classNames(
        'btn btn-discreet-secondary',
        { 'btn-xl': !isSmall, 'btn-lg': isSmall, 'btn-icon': iconOnly, 'btn-icon-start': !iconOnly },
        className,
      )}
      {...props}
    >
      {!iconOnly && <FormattedMessage id="lifeRing.helpRequest" />}
      <em className="icon icon-outlined">live_help</em>
    </HelpRequestButton>
  );
}
